import React, { Component } from 'react';
import './SecundaryButton.scss';


class SecundaryButton extends Component<{icon: any, text: string, action?:any},{}> {
  
  /**
   * Main render method
   */
  render() {
    return (
        <div className="secundary" onClick={()=>{
          if(this.props.action) {
            this.props.action();
          }
        }}>
          <img src={this.props.icon} className="secundary-image" alt="icon"/>
          <div className="secundary-text">{this.props.text}</div>
        </div>
    );
  }
}

export default SecundaryButton;
